import React from 'react'

import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../EditableSentence'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import { prop, propEq } from 'ramda'
import { OPTIONS_RELATIVE } from '../_shared/constants'

const FieldSentence = () => {
  const form = useForm()

  const { handleChangeIn } = useFormState()

  const filteredOptions = OPTIONS_RELATIVE.filter(option => form.entity === option.entity)

  const field = prop('field')(form?.configuration)

  const handleChange = option => handleChangeIn(['configuration', 'field'], option.value)

  const value = OPTIONS_RELATIVE.find(propEq('value', field))

  const label = value?.name || '_________'

  return (
    <>
      <Text size="h2"> </Text>
      <EditableSentence
        label={label || '_________'}
        field="field"
        value={value}
        path={['configuration', 'field']}
        onChange={handleChange}
        options={filteredOptions}
        truncate={15}
        width={10}
      />
    </>
  )
}

export default FieldSentence
